import { PropsWithChildren, ReactNode } from "react";
import styled, { css } from "styled-components";
import { useContentMargins } from "@songtradr-sso/shared/frontend";
import { staticText } from "../../shared/statics/static-text";

// TEXT
export const text = staticText.pageContainer;

// STYLES
export const Wrapper = styled.div<{
  $floatTop: boolean;
  $background?: string;
}>(({ $floatTop, $background }) => {
  const [margin] = useContentMargins();

  return css`
    display: flex;
    justify-content: center;
    align-items: ${$floatTop ? "flex-start" : "center"};
    min-height: 100vh;
    padding: ${$floatTop ? "7rem" : "3rem"} ${margin};

    ${$background &&
    css`
      background: url(${$background}) no-repeat center;
      background-size: cover;
    `}
  `;
});

/** @todo - this will overlap the content on some mobile pages (i.e. signup) */
export const BackButtonContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  position: fixed;
  left: 3rem;
  top: 3rem;
`;

/** @todo - this will overlap the content on some mobile pages (i.e. signup) */
export const Footer = styled.div`
  display: flex;
  gap: 1.5rem;
  position: fixed;
  left: 3rem;
  bottom: 1rem;
`;

export const HiddenHeaderSpacer = styled.div`
  visibility: hidden;
`;

// DATA

// TYPES
export interface Props extends PropsWithChildren {
  header?: ReactNode;
  background?: string;
  floatTop?: boolean;
  backButton?: boolean | (() => void);
  changeWorkspaceButton?: boolean;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
